import { Status } from "../Config/Status.js";
import { Options } from "../Config/Options.js";

const Animation = {
  dom : document.getElementsByClassName('js-anime'),
  options: {
    shiftPoint : Options.breakpoint.tb,
    offset : {pc: 5, sp: 10},
  },
  update() {
    Array.from(this.dom).map(elm => {
      let shift;
      const position = elm.getBoundingClientRect().top;

      if (Status.winWidth < this.options.shiftPoint) {
        shift = Status.winHeight / this.options.offset.sp;
      } else {
        shift = Status.winHeight / this.options.offset.pc;
      }

      if(position < Status.winHeight - shift) {
        elm.classList.add('is-anime'); 
      }
    });
  },
  reset() {
    Array.from(this.dom).map(elm => {
      elm.classList.remove('is-anime');
    });
  }
}

export default Animation;